import { render, staticRenderFns } from "./range.vue?vue&type=template&id=72bf52c8&"
import script from "./range.vue?vue&type=script&lang=js&"
export * from "./range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports